import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-multi-select';
import '@maersk-global/mds-components-core/mc-button';
import '@maersk-global/mds-components-core-radio-group';
import '@maersk-global/mds-components-core-radio';
import { ContainerGradeRepairCodeFilterForm } from '../../../form-model/container-grade-repair-code-filter.form.model';
import { ContainerGradeRepairCodeService, RepairCodeOption } from '../../../services/container-grade-repair-code.service';
import { firstValueFrom } from 'rxjs';

export const GRADE_OPTIONS: string[] = ['E', 'K', 'M', 'Q', 'S'];

@Component({
  selector: 'app-container-grade-repair-code-advanced-filter',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './container-grade-repair-code-advanced-filter.component.html',
  styleUrl: './container-grade-repair-code-advanced-filter.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContainerGradeRepairCodeAdvancedFilterComponent implements OnInit {
  @Input({ required: true }) filterForm!: FormGroup<ContainerGradeRepairCodeFilterForm>;

  repairCodeOptions: RepairCodeOption[] = [];
  modeOptions: string[] = [];
  gradeOptions = GRADE_OPTIONS;
  isLoadingCodes = false;
  isLoadingModes = false;

  constructor(
    private readonly service: ContainerGradeRepairCodeService,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.addControlsToFormGroup();
    this.loadFilterOptions();
  }

  private addControlsToFormGroup(): void {
    const form = this.filterForm;
    if (!form.get('RepairCodeList')) {
      form.addControl('RepairCodeList', this.formBuilder.control<string[] | null>(null));
    }
    if (!form.get('RepairModeList')) {
      form.addControl('RepairModeList', this.formBuilder.control<string[] | null>(null));
    }
    if (!form.get('GradesApplicableList')) {
      form.addControl('GradesApplicableList', this.formBuilder.control<string[] | null>(null));
    }
    if (!form.get('GenerateGradeChange')) {
      form.addControl('GenerateGradeChange', this.formBuilder.control<string | null>(null));
    }
  }

  private async loadFilterOptions(): Promise<void> {
    this.isLoadingCodes = true;
    this.isLoadingModes = true;
    try {
      this.repairCodeOptions = await firstValueFrom(this.service.getAllCodes());
    } catch {
      this.repairCodeOptions = [];
    } finally {
      this.isLoadingCodes = false;
    }
    try {
      this.modeOptions = await firstValueFrom(this.service.getAllModes());
    } catch {
      this.modeOptions = [];
    } finally {
      this.isLoadingModes = false;
    }
  }

  applyFilters(): void {
    this.filterForm.get('applyFilter')?.setValue(true);
  }

  clearFilters(): void {
    this.filterForm.reset({ RepairCodeList: null, RepairModeList: null, GradesApplicableList: null, GenerateGradeChange: null });
    this.filterForm.get('applyFilter')?.setValue(true);
  }
}
